export default "__VITE_ASSET__Th8GRicj__$_?component__"